
// client/generated/CardArt.ts
// @generated

import ArtAcademy from '../../assets/card_images/ArtAcademy.webp';
import ArtAcolyteOfZeona from '../../assets/card_images/ArtAcolyteOfZeona.webp';
import ArtAcropolis from '../../assets/card_images/ArtAcropolis.webp';
import ArtAltarOfBounty from '../../assets/card_images/ArtAltarOfBounty.webp';
import ArtAmbush from '../../assets/card_images/ArtAmbush.webp';
import ArtAqueduct from '../../assets/card_images/ArtAqueduct.webp';
import ArtArchitect from '../../assets/card_images/ArtArchitect.webp';
import ArtAscension from '../../assets/card_images/ArtAscension.webp';
import ArtAxeman from '../../assets/card_images/ArtAxeman.webp';
import ArtBarracks from '../../assets/card_images/ArtBarracks.webp';
import ArtBastion from '../../assets/card_images/ArtBastion.webp';
import ArtBathhouse from '../../assets/card_images/ArtBathhouse.webp';
import ArtBattleHymn from '../../assets/card_images/ArtBattleHymn.webp';
import ArtBlessedBounty from '../../assets/card_images/ArtBlessedBounty.webp';
import ArtBlessedMight from '../../assets/card_images/ArtBlessedMight.webp';
import ArtCaptain from '../../assets/card_images/ArtCaptain.webp';
import ArtCaravan from '../../assets/card_images/ArtCaravan.webp';
import ArtCitadel from '../../assets/card_images/ArtCitadel.webp';
import ArtCityWalls from '../../assets/card_images/ArtCityWalls.webp';
import ArtCommander from '../../assets/card_images/ArtCommander.webp';
import ArtConscription from '../../assets/card_images/ArtConscription.webp';
import ArtCourthouse from '../../assets/card_images/ArtCourthouse.webp';
import ArtCraftsman from '../../assets/card_images/ArtCraftsman.webp';
import ArtDespoticLeader from '../../assets/card_images/ArtDespoticLeader.webp';
import ArtDivineBlessing from '../../assets/card_images/ArtDivineBlessing.webp';
import ArtFarm from '../../assets/card_images/ArtFarm.webp';
import ArtFolkHero from '../../assets/card_images/ArtFolkHero.webp';
import ArtForge from '../../assets/card_images/ArtForge.webp';
import ArtFruitsOfLabor from '../../assets/card_images/ArtFruitsOfLabor.webp';
import ArtGate from '../../assets/card_images/ArtGate.webp';
import ArtGlory from '../../assets/card_images/ArtGlory.webp';
import ArtGranary from '../../assets/card_images/ArtGranary.webp';
import ArtGrandSiege from '../../assets/card_images/ArtGrandSiege.webp';
import ArtGreatOliveTree from '../../assets/card_images/ArtGreatOliveTree.webp';
import ArtGrowth from '../../assets/card_images/ArtGrowth.webp';
import ArtGuardHound from '../../assets/card_images/ArtGuardHound.webp';
import ArtGuardTower from '../../assets/card_images/ArtGuardTower.webp';
import ArtGuidance from '../../assets/card_images/ArtGuidance.webp';
import ArtGuildhall from '../../assets/card_images/ArtGuildhall.webp';
import ArtHallOfChampions from '../../assets/card_images/ArtHallOfChampions.webp';
import ArtHarvestSeason from '../../assets/card_images/ArtHarvestSeason.webp';
import ArtHeroesFeast from '../../assets/card_images/ArtHeroesFeast.webp';
import ArtHighPriest from '../../assets/card_images/ArtHighPriest.webp';
import ArtHolyDay from '../../assets/card_images/ArtHolyDay.webp';
import ArtHonorTheFallen from '../../assets/card_images/ArtHonorTheFallen.webp';
import ArtHoplite from '../../assets/card_images/ArtHoplite.webp';
import ArtHorseman from '../../assets/card_images/ArtHorseman.webp';
import ArtJusticiar from '../../assets/card_images/ArtJusticiar.webp';
import ArtLayFoundation from '../../assets/card_images/ArtLayFoundation.webp';
import ArtLeader from '../../assets/card_images/ArtLeader.webp';
import ArtLegionnaire from '../../assets/card_images/ArtLegionnaire.webp';
import ArtLibrary from '../../assets/card_images/ArtLibrary.webp';
import ArtLighthouse from '../../assets/card_images/ArtLighthouse.webp';
import ArtMarchOnward from '../../assets/card_images/ArtMarchOnward.webp';
import ArtMarketplace from '../../assets/card_images/ArtMarketplace.webp';
import ArtMercantileLeader from '../../assets/card_images/ArtMercantileLeader.webp';
import ArtMercenary from '../../assets/card_images/ArtMercenary.webp';
import ArtMerchant from '../../assets/card_images/ArtMerchant.webp';
import ArtConqueringLeader from '../../assets/card_images/ArtConqueringLeader.webp';
import ArtMilitia from '../../assets/card_images/ArtMilitia.webp';
import ArtMillOfDerion from '../../assets/card_images/ArtMillOfDerion.webp';
import ArtMiningCamp from '../../assets/card_images/ArtMiningCamp.webp';
import ArtNewRoads from '../../assets/card_images/ArtNewRoads.webp';
import ArtOathToDerion from '../../assets/card_images/ArtOathToDerion.webp';
import ArtOathToTyros from '../../assets/card_images/ArtOathToTyros.webp';
import ArtOathToZeona from '../../assets/card_images/ArtOathToZeona.webp';
import ArtOracle from '../../assets/card_images/ArtOracle.webp';
import ArtPiety from '../../assets/card_images/ArtPiety.webp';
import ArtPillage from '../../assets/card_images/ArtPillage.webp';
import ArtPiousLeader from '../../assets/card_images/ArtPiousLeader.webp';
import ArtPoet from '../../assets/card_images/ArtPoet.webp';
import ArtPrizedOx from '../../assets/card_images/ArtPrizedOx.webp';
import ArtProphet from '../../assets/card_images/ArtProphet.webp';
import ArtRanger from '../../assets/card_images/ArtRanger.webp';
import ArtRitualOfGrowth from '../../assets/card_images/ArtRitualOfGrowth.webp';
import ArtRitualOfHeroes from '../../assets/card_images/ArtRitualOfHeroes.webp';
import ArtRitualOfMyths from '../../assets/card_images/ArtRitualOfMyths.webp';
import ArtScavenge from '../../assets/card_images/ArtScavenge.webp';
import ArtScout from '../../assets/card_images/ArtScout.webp';
import ArtScribe from '../../assets/card_images/ArtScribe.webp';
import ArtSenate from '../../assets/card_images/ArtSenate.webp';
import ArtSettlement from '../../assets/card_images/ArtSettlement.webp';
import ArtSoldierOfTyros from '../../assets/card_images/ArtSoldierOfTyros.webp';
import ArtStonemason from '../../assets/card_images/ArtStonemason.webp';
import ArtStrategist from '../../assets/card_images/ArtStrategist.webp';
import ArtStrength from '../../assets/card_images/ArtStrength.webp';
import ArtSwordsman from '../../assets/card_images/ArtSwordsman.webp';
import ArtTemple from '../../assets/card_images/ArtTemple.webp';
import ArtTempleGuard from '../../assets/card_images/ArtTempleGuard.webp';
import ArtTownHall from '../../assets/card_images/ArtTownHall.webp';
import ArtTrader from '../../assets/card_images/ArtTrader.webp';
import ArtTradingPost from '../../assets/card_images/ArtTradingPost.webp';
import ArtTrainingCamp from '../../assets/card_images/ArtTrainingCamp.webp';
import ArtVillager from '../../assets/card_images/ArtVillager.webp';
import ArtVineyard from '../../assets/card_images/ArtVineyard.webp';
import ArtWanderingLeader from '../../assets/card_images/ArtWanderingLeader.webp';
import ArtWarHistorian from '../../assets/card_images/ArtWarHistorian.webp';
import ArtWarrior from '../../assets/card_images/ArtWarrior.webp';
import ArtWorship from '../../assets/card_images/ArtWorship.webp';
import TributeArtAllIn from '../../assets/card_images/TributeArtAllIn.webp';
import TributeArtBringPeace from '../../assets/card_images/TributeArtBringPeace.webp';
import TributeArtGrowBounty from '../../assets/card_images/TributeArtGrowBounty.webp';
import TributeArtGrowCommunity from '../../assets/card_images/TributeArtGrowCommunity.webp';
import TributeArtGrowConquest from '../../assets/card_images/TributeArtGrowConquest.webp';
import TributeArtGrowFaith from '../../assets/card_images/TributeArtGrowFaith.webp';
import TributeArtGrowLegend from '../../assets/card_images/TributeArtGrowLegend.webp';
import TributeArtGrowPolis from '../../assets/card_images/TributeArtGrowPolis.webp';
import TributeArtImpulsiveChoice from '../../assets/card_images/TributeArtImpulsiveChoice.webp';
import TributeArtOverpower from '../../assets/card_images/TributeArtOverpower.webp';
import TributeArtPatientChoice from '../../assets/card_images/TributeArtPatientChoice.webp';
import TributeArtPersevere from '../../assets/card_images/TributeArtPersevere.webp';
import TributeArtPunishWeakness from '../../assets/card_images/TributeArtPunishWeakness.webp';
import TributeArtSeekHumility from '../../assets/card_images/TributeArtSeekHumility.webp';
import TributeArtSeekModesty from '../../assets/card_images/TributeArtSeekModesty.webp';
import TributeArtSeekWonder from '../../assets/card_images/TributeArtSeekWonder.webp';
import TributeArtShowMight from '../../assets/card_images/TributeArtShowMight.webp';
import TributeArtShowPiety from '../../assets/card_images/TributeArtShowPiety.webp';

export const CardArt = {
  "ArtAcademy": ArtAcademy,
  "ArtAcolyteOfZeona": ArtAcolyteOfZeona,
  "ArtAcropolis": ArtAcropolis,
  "ArtAltarOfBounty": ArtAltarOfBounty,
  "ArtAmbush": ArtAmbush,
  "ArtAqueduct": ArtAqueduct,
  "ArtArchitect": ArtArchitect,
  "ArtAscension": ArtAscension,
  "ArtAxeman": ArtAxeman,
  "ArtBarracks": ArtBarracks,
  "ArtBastion": ArtBastion,
  "ArtBathhouse": ArtBathhouse,
  "ArtBattleHymn": ArtBattleHymn,
  "ArtBlessedBounty": ArtBlessedBounty,
  "ArtBlessedMight": ArtBlessedMight,
  "ArtCaptain": ArtCaptain,
  "ArtCaravan": ArtCaravan,
  "ArtCitadel": ArtCitadel,
  "ArtCityWalls": ArtCityWalls,
  "ArtCommander": ArtCommander,
  "ArtConscription": ArtConscription,
  "ArtCourthouse": ArtCourthouse,
  "ArtCraftsman": ArtCraftsman,
  "ArtDespoticLeader": ArtDespoticLeader,
  "ArtDivineBlessing": ArtDivineBlessing,
  "ArtFarm": ArtFarm,
  "ArtFolkHero": ArtFolkHero,
  "ArtForge": ArtForge,
  "ArtFruitsOfLabor": ArtFruitsOfLabor,
  "ArtGate": ArtGate,
  "ArtGlory": ArtGlory,
  "ArtGranary": ArtGranary,
  "ArtGrandSiege": ArtGrandSiege,
  "ArtGreatOliveTree": ArtGreatOliveTree,
  "ArtGrowth": ArtGrowth,
  "ArtGuardHound": ArtGuardHound,
  "ArtGuardTower": ArtGuardTower,
  "ArtGuidance": ArtGuidance,
  "ArtGuildhall": ArtGuildhall,
  "ArtHallOfChampions": ArtHallOfChampions,
  "ArtHarvestSeason": ArtHarvestSeason,
  "ArtHeroesFeast": ArtHeroesFeast,
  "ArtHighPriest": ArtHighPriest,
  "ArtHolyDay": ArtHolyDay,
  "ArtHonorTheFallen": ArtHonorTheFallen,
  "ArtHoplite": ArtHoplite,
  "ArtHorseman": ArtHorseman,
  "ArtJusticiar": ArtJusticiar,
  "ArtLayFoundation": ArtLayFoundation,
  "ArtLeader": ArtLeader,
  "ArtLegionnaire": ArtLegionnaire,
  "ArtLibrary": ArtLibrary,
  "ArtLighthouse": ArtLighthouse,
  "ArtMarchOnward": ArtMarchOnward,
  "ArtMarketplace": ArtMarketplace,
  "ArtMercantileLeader": ArtMercantileLeader,
  "ArtMercenary": ArtMercenary,
  "ArtMerchant": ArtMerchant,
  "ArtConqueringLeader": ArtConqueringLeader,
  "ArtMilitia": ArtMilitia,
  "ArtMillOfDerion": ArtMillOfDerion,
  "ArtMiningCamp": ArtMiningCamp,
  "ArtNewRoads": ArtNewRoads,
  "ArtOathToDerion": ArtOathToDerion,
  "ArtOathToTyros": ArtOathToTyros,
  "ArtOathToZeona": ArtOathToZeona,
  "ArtOracle": ArtOracle,
  "ArtPiety": ArtPiety,
  "ArtPillage": ArtPillage,
  "ArtPiousLeader": ArtPiousLeader,
  "ArtPoet": ArtPoet,
  "ArtPrizedOx": ArtPrizedOx,
  "ArtProphet": ArtProphet,
  "ArtRanger": ArtRanger,
  "ArtRitualOfGrowth": ArtRitualOfGrowth,
  "ArtRitualOfHeroes": ArtRitualOfHeroes,
  "ArtRitualOfMyths": ArtRitualOfMyths,
  "ArtScavenge": ArtScavenge,
  "ArtScout": ArtScout,
  "ArtScribe": ArtScribe,
  "ArtSenate": ArtSenate,
  "ArtSettlement": ArtSettlement,
  "ArtSoldierOfTyros": ArtSoldierOfTyros,
  "ArtStonemason": ArtStonemason,
  "ArtStrategist": ArtStrategist,
  "ArtStrength": ArtStrength,
  "ArtSwordsman": ArtSwordsman,
  "ArtTemple": ArtTemple,
  "ArtTempleGuard": ArtTempleGuard,
  "ArtTownHall": ArtTownHall,
  "ArtTrader": ArtTrader,
  "ArtTradingPost": ArtTradingPost,
  "ArtTrainingCamp": ArtTrainingCamp,
  "ArtVillager": ArtVillager,
  "ArtVineyard": ArtVineyard,
  "ArtWanderingLeader": ArtWanderingLeader,
  "ArtWarHistorian": ArtWarHistorian,
  "ArtWarrior": ArtWarrior,
  "ArtWorship": ArtWorship,
};

export const TributeArt = {
  "TributeArtAllIn": TributeArtAllIn,
  "TributeArtBringPeace": TributeArtBringPeace,
  "TributeArtGrowBounty": TributeArtGrowBounty,
  "TributeArtGrowCommunity": TributeArtGrowCommunity,
  "TributeArtGrowConquest": TributeArtGrowConquest,
  "TributeArtGrowFaith": TributeArtGrowFaith,
  "TributeArtGrowLegend": TributeArtGrowLegend,
  "TributeArtGrowPolis": TributeArtGrowPolis,
  "TributeArtImpulsiveChoice": TributeArtImpulsiveChoice,
  "TributeArtOverpower": TributeArtOverpower,
  "TributeArtPatientChoice": TributeArtPatientChoice,
  "TributeArtPersevere": TributeArtPersevere,
  "TributeArtPunishWeakness": TributeArtPunishWeakness,
  "TributeArtSeekHumility": TributeArtSeekHumility,
  "TributeArtSeekModesty": TributeArtSeekModesty,
  "TributeArtSeekWonder": TributeArtSeekWonder,
  "TributeArtShowMight": TributeArtShowMight,
  "TributeArtShowPiety": TributeArtShowPiety,
};
